import { Controller } from "stimulus"
import $ from 'jquery'
import 'materialize-css/dist/js/materialize';

export default class extends Controller {
  connect() {
    M.textareaAutoResize($('#note_description'));
  }
}
